import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { showHubTeamToast } from "../utils/hub_team_toast"

export default class extends Controller {
  static targets = ["modal", "title", "description", "submitButton"]
  static values = { url: String }

  connect() {
    this.selectedCount = 0
  }

  open(event) {
    event.preventDefault()

    const selectedIds = this.selectedIds()
    if (selectedIds.length === 0) return

    this.selectedCount = selectedIds.length
    this.updateCopy(selectedIds.length)
    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  async save(event) {
    event.preventDefault()

    const selectedIds = this.selectedIds()
    if (selectedIds.length === 0 || !this.hasUrlValue) return

    this.setSaving(true)

    const formData = new FormData()
    selectedIds.forEach((id) => formData.append("company_user_ids[]", id))

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      const data = await response.json()

      if (response.ok && data.success) {
        this.clearSelection()
        Modal.getOrCreateInstance(this.modalTarget).hide()
      } else {
        const message = data?.errors?.join(", ") || `HTTP ${response.status}`
        showHubTeamToast(`Failed to resend invitations: ${message}`, { variant: "error" })
      }
    } catch (error) {
      console.error("Error resending invitations:", error)
      showHubTeamToast("An error occurred. Please try again.", { variant: "error" })
    } finally {
      this.setSaving(false)
    }
  }

  updateCopy(count) {
    const noun = count === 1 ? "member" : "members"

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = `Resend setup email to ${count} ${noun}`
    }

    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent =
        `A new setup link will be sent to ${count} ${noun}. Previous links will expire immediately.`
    }

    if (this.hasSubmitButtonTarget && this.submitButtonTarget.dataset.saving !== "true") {
      this.submitButtonTarget.textContent = count === 1 ? "Resend to 1 member" : `Resend to ${count} members`
    }
  }

  selectedIds() {
    return [...this.element.querySelectorAll('[data-bulk-select-target="checkbox"]:checked')]
      .filter((checkbox) => !checkbox.closest("tr[hidden]"))
      .map((checkbox) => checkbox.value)
  }

  clearSelection() {
    const bulkSelectElement = this.element.querySelector('[data-controller~="bulk-select"]')
    if (!bulkSelectElement) return

    const controller = this.application.getControllerForElementAndIdentifier(bulkSelectElement, "bulk-select")
    controller?.clearSelection()
  }

  setSaving(saving) {
    if (!this.hasSubmitButtonTarget) return

    this.submitButtonTarget.dataset.saving = saving ? "true" : "false"
    this.submitButtonTarget.disabled = saving

    if (saving) {
      this.submitButtonTarget.textContent = "Sending..."
    } else {
      this.updateCopy(this.selectedCount)
    }
  }
}
